import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("h2", { class: "mt-4" }, "ユーザ情報")
], -1)
const _hoisted_3 = ["onSubmit"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "float-start mt-1" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "h5" }, [
      /*#__PURE__*/_createElementVNode("b", null, "検索")
    ])
  ])
], -1)
const _hoisted_5 = { class: "card-body row g-3" }
const _hoisted_6 = { class: "col-md-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "userStatus"
}, "ステータス", -1)
const _hoisted_8 = { class: "col-md-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "prefecture"
}, "都道府県", -1)
const _hoisted_10 = { class: "col-12" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "municipalityName"
}, "自治体名", -1)
const _hoisted_12 = { class: "col-md-6" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "departmentName"
}, "部署名", -1)
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "userName"
}, "担当者名", -1)
const _hoisted_16 = { class: "card-footer text-center" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn btn-success"
}, "検索", -1)
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  key: 0,
  class: "table table-hover table-bordered"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "ステータス"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "都道府県名"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "自治体名"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "部署名"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "担当者名"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "電話番号"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "メールアドレス"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      style: {"width":"60px"}
    }, "編集"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" })
  ])
], -1)
const _hoisted_21 = ["onClick"]
const _hoisted_22 = {
  key: 1,
  class: "alert alert-warning",
  role: "alert"
}

import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from '@/store'
import { Municipality, User, useNicotto, UserListFilter } from '@/plugins/nicotto'
import { usePrefecture } from '@/plugins/prefecture'
import { message } from '@/plugins/message'
import InputPref from '@/components/ui/InputPref.vue'
import InputUserStatus from "@/components/ui/InputUserStatus.vue"
import IconPenToSquare from '@/components/ui/IconPenToSquare.vue'
import ButtonLink from "@/components/ui/ButtonLink.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'IndexView',
  setup(__props) {

const router = useRouter()
const store = useStore()
const nicotto = useNicotto()
const filter = ref<UserListFilter>({})
const users = ref<User[]>([])
const prefecture = usePrefecture()
const getPrefName = (id: number|undefined) => {
  return id ? prefecture.getName(id) : ''
}
const noResultMessage = ref('')

// 自治体メニュー切替
const switchMunicipality = (municipality: Municipality|null) => {
  nicotto.account.switchMunicipality(municipality)
  store.commit('setMunicipality', municipality)
  if (municipality) {
    router.push('/')
  }
}
switchMunicipality(null) // 自治体を初期化

const status =
  {
    enabled: {
      name: '有効',
      class: 'bg-success'
    },
    disabled: {
      name: '無効',
      class: 'bg-secondary'
    },
    notAccepted: {
      name: '未承認',
      class: 'bg-warning text-dark'
    },
  }

// 検索
const resetFilter = () => {
  filter.value = {}
}
const search = async() => {
  noResultMessage.value = ''
  users.value = await nicotto.account.getMunicipalityUserList(filter.value)
  if (users.value.length == 0) {
    noResultMessage.value = message('user.noSearchResult')
  }
}
search() // 初期表示

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("form", {
      class: "card mt-3 mb-4",
      onSubmit: _withModifiers(search, ["prevent"])
    }, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(InputUserStatus, {
            id: "userStatus",
            modelValue: filter.value.status,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filter.value.status) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createVNode(InputPref, {
            id: "prefecture",
            modelValue: filter.value.prefecture,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filter.value.prefecture) = $event)),
            name: "prefectures"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _withDirectives(_createElementVNode("input", {
            id: "municipalityName",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filter.value.municipalityName) = $event)),
            type: "text",
            class: "form-control"
          }, null, 512), [
            [_vModelText, filter.value.municipalityName]
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _withDirectives(_createElementVNode("input", {
            id: "departmentName",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filter.value.departmentName) = $event)),
            type: "text",
            class: "form-control"
          }, null, 512), [
            [_vModelText, filter.value.departmentName]
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _withDirectives(_createElementVNode("input", {
            id: "userName",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filter.value.userName) = $event)),
            type: "text",
            class: "form-control"
          }, null, 512), [
            [_vModelText, filter.value.userName]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _createElementVNode("a", {
          class: "btn btn-link ml-3",
          href: "#",
          role: "button",
          onClick: _withModifiers(resetFilter, ["prevent"])
        }, "検索条件をクリア", 8, _hoisted_18)
      ])
    ], 40, _hoisted_3),
    (users.value.length > 0)
      ? (_openBlock(), _createElementBlock("table", _hoisted_19, [
          _hoisted_20,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(users.value, (user) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: user.userId
              }, [
                _createElementVNode("td", null, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["badge", status[user.status()]['class']])
                  }, _toDisplayString(status[user.status()]['name']), 3)
                ]),
                _createElementVNode("td", null, _toDisplayString(getPrefName(user.municipality?.prefecture)), 1),
                _createElementVNode("td", null, _toDisplayString(user.municipality?.name), 1),
                _createElementVNode("td", null, _toDisplayString(user.department), 1),
                _createElementVNode("td", null, _toDisplayString(user.name), 1),
                _createElementVNode("td", null, _toDisplayString(user.tel), 1),
                _createElementVNode("td", null, _toDisplayString(user.email), 1),
                _createElementVNode("td", null, [
                  _createVNode(ButtonLink, {
                    class: "btn-primary",
                    to: `/users/${user.userId}`,
                    title: "編集"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(IconPenToSquare)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("button", {
                    class: "btn btn-success",
                    type: "button",
                    onClick: ($event: any) => (switchMunicipality(user.municipality))
                  }, "自治体メニュー", 8, _hoisted_21)
                ])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (noResultMessage.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(noResultMessage.value), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})